let mutationObserver
let reviewForm

const mutationConfig = {
    attributes: false,
    childList: true,
    subtree: true
}

export function reviewHoverLabels(context = document) {
    let inputEls = context.querySelectorAll('.new-review-form input, .new-review-form textarea')

    if (!inputEls.length) {
        mutationObserver = new MutationObserver(handleMutation)
        mutationObserver.observe(document.body, mutationConfig)
    } else {
        init(inputEls)
    }
}

function handleMutation(mutationList) {
    for (const mutation of mutationList) {
        if (mutation.type === 'childList') {
            reviewForm = mutation.target.querySelector('.new-review-form')

            if (reviewForm) {
                let inputEls = reviewForm.querySelectorAll('input, textarea')
                init(inputEls)
                mutationObserver.disconnect()
                break
            }
        }
    }
}

function init(inputEls) {
    let inputs = Array.from(inputEls).map((el) => {
        let element = el.parentElement

        if (el.tagName === 'TEXTAREA') {
            element = el.parentElement.parentElement
        }

        return {
            el: element,
            input: el
        }
    })

    setupInitialState(inputs)
    addEventListeners(inputs)
}

function setupInitialState(inputs) {
    inputs.forEach(({ el, input }) => {
        if (el.dataset.hoverSetup) {
            return
        }

        if (!input.value) {
            el.removeAttribute('data-active')
        } else if (!el.dataset.active) {
            el.dataset.active = true
        }

        el.dataset.hoverSetup = true
    })
}

function addEventListeners(inputs) {
    inputs.forEach(({ input }) => {
        if (input.tagName === 'SELECT') {
            input.addEventListener('showDropdown', handleFocus)
            input.addEventListener('hideDropdown', handleBlur)
        } else {
            input.addEventListener('focus', handleFocus)
            input.addEventListener('blur', handleBlur)
        }
    })
}

function handleFocus(evt) {
    let target = evt.target.parentElement

    if (evt.target.tagName === 'TEXTAREA') {
        target = evt.target.parentElement.parentElement
    }

    if (!target) return
    target.dataset.active = true
}

function handleBlur(evt) {
    let target = evt.target.parentElement

    if (evt.target.tagName === 'TEXTAREA') {
        target = evt.target.parentElement.parentElement
    }

    if (!target) return
    if (!evt.target.value) {
        target.removeAttribute('data-active')
    }
}
